import React from 'react'

const RequiredDecorator = () => <span className="required-asterisk">*</span>

export default RequiredDecorator
